import { GameModeBase } from '../store/AppState';

export const selectEdgeCenter = (a: string, b: string) => (state: GameModeBase) => {
    const [ax, ay] = state.game.nodes[a].position;
    const [bx, by] = state.game.nodes[b].position;
    const x = (ax + bx) / 2;
    const y = (ay + by) / 2;
    return [x, y];
};
